import { COLORS as DefaultColors } from "../sub/theme/colors";

const appColors = {
  primary: "#FFBD2F",
  primaryVariant: "#FFF4DD",
  secondary: "#5D9B5A",
  secondaryVariant: "#E8F5E8",
  tertiary: "#757575",
  tertiaryVariant: "#F6F6F6",
  quaternary: "#013764",
  quaternaryVariant: "#D8F2FF",

  red: "#D3302F",
  redVariant: "#F9E0DF",

  greenLink: "#2A6427",

  background: "#ffffff",
  surface: "#ffffff",
  surfaceVariant: "#f2f2f2",
  inverseSurface: "#000000",

  onPrimary: "#000000",

  border: "#735708",
};

export const COLORS = { ...DefaultColors, ...appColors };
